import { useState, useEffect } from 'react';
import { PHONE_1_DISPLAY, PHONE_1 } from './TopBar';

const LOGO = 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/1c2c476bf3b5fc883cb26c7a37ec5870.jpeg';

const navLinks = [
  { label: 'Hizmetler', href: '#services' },
  { label: 'Fiyatlar', href: '#pricing' },
  { label: 'Nasıl Çalışır', href: '#how-it-works' },
  { label: 'Yorumlar', href: '#reviews' },
  { label: 'SSS', href: '#faq' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  const handleNav = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      className={`w-full sticky top-0 z-40 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
        {/* Logo */}
        <a href="#" className="flex items-center gap-3 cursor-pointer">
          <img
            src={LOGO}
            alt="Logo"
            className="w-12 h-12 rounded-full object-cover object-top"
          />
          <span
            className={`font-bold text-lg leading-tight hidden sm:block ${
              scrolled ? 'text-[#1a1a1a]' : 'text-white'
            }`}
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            Temizlik
            <span className="text-emerald-500 font-extrabold"> Fırsatı</span>
          </span>
        </a>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-6">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => handleNav(e, l.href)}
              className={`text-sm font-medium hover:text-emerald-500 transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              {l.label}
            </a>
          ))}
        </div>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href={`tel:${PHONE_1}`}
            className="flex items-center gap-1.5 text-sm font-semibold text-emerald-500 hover:text-emerald-600 whitespace-nowrap transition-colors"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-fill" />
            </span>
            {PHONE_1_DISPLAY}
          </a>
          <a
            href="#appointment"
            onClick={(e) => handleNav(e, '#appointment')}
            className="bg-emerald-500 hover:bg-emerald-600 text-white text-sm font-semibold px-5 py-2.5 rounded-xl transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Randevu Al
          </a>
        </div>

        {/* Mobile hamburger */}
        <button
          className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg ${
            scrolled ? 'text-[#1a1a1a]' : 'text-white'
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-4 py-4 flex flex-col gap-3 shadow-lg">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => handleNav(e, l.href)}
              className="text-gray-700 font-medium py-2 border-b border-gray-50 hover:text-emerald-500 transition-colors cursor-pointer"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#appointment"
            onClick={(e) => handleNav(e, '#appointment')}
            className="bg-emerald-500 text-white text-center font-semibold py-3 rounded-xl mt-2 cursor-pointer"
          >
            Hemen Randevu Al
          </a>
        </div>
      )}
    </nav>
  );
}
